import { Component, OnInit } from '@angular/core';
import { RestService } from '../rest.service';
import { UserService } from '../user.service';

@Component({
  selector: 'app-notificaciones',
  templateUrl: './notificaciones.component.html',
  styleUrls: ['./notificaciones.component.scss']
})
export class NotificacionesComponent implements OnInit {

  notificaciones: any[] = [];
  length: number;

  constructor(
    private rest: RestService,
    private user: UserService
  ) {
    this.GetNotificaciones();
  }

  ngOnInit() {
    setInterval(
      () => this.GetNotificaciones() , 15000);
  }

  GetNotificaciones() {

    this.rest.GetNotificaciones().subscribe( (data) => {

      this.notificaciones = data['data'];

      if ( !this.length ) {
        this.length = data['data']['length'];
      } else {

        if ( this.length !== data['data']['length']) {

          this.length = data['data']['length'];
          console.log('this.length', this.length , 'data', data['data']['length']);
          this.user.playAudio();
        }

      }


    });
  }


}
